import React from 'react'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import { Card, Row } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { apiGenerator } from '../../../../util/functions'
import moment from 'moment'
import Heading from '../../../../component/common/Heading'

const Pets = () => {

    const { id } = useParams()
    const navigate = useNavigate()

    const userPetApi = apiGenerator(CONSTANTS.API.Pet.getAll, {}, `?userId=${id}`)

    // console.log(userFeedBackApi);
    return (
        <>
            <Card>
                <Heading>Pets</Heading>

                <Row>
                    <CRUDComponent
                        GET={{
                            API: userPetApi,
                            DataModifier: (res, API, Setrefresh) => {
                                // console.log(res, "GET ALL ABCD");
                                return res?.map(data => {
                                    return {
                                        ...data,
                                        no: `P${data?.id.toString().padStart(7, "0")}`,
                                        dob: moment(data?.dob).format("DD MMM YYYY"),
                                        isBlocked: {
                                            checked: !data?.isBlock,
                                            id: data?.id,
                                            onClick: (id, val) => {
                                                const UpdateAPIEnd = { ...CONSTANTS?.API.Pet.update };
                                                UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                                                API.sendRequest(
                                                    UpdateAPIEnd,
                                                    () => {
                                                        Setrefresh((prev) => !prev);
                                                    },
                                                    { isBlock: val },
                                                    `Pet ${val ? "Blocked" : "Unblocked"} Successfully`
                                                );
                                            },
                                            // onClick: () => { }
                                        },
                                        view: {
                                            id: data?.id,
                                            onClick: () => {
                                                navigate(`/app/pets/${data?.id}`)
                                            }
                                        }
                                    }
                                })
                            },
                            column: CONSTANTS.TABLE.USER_PETS,
                        }}
                        isSearch={true}

                    />
                </Row>

            </Card>
        </>
    )
}

export default Pets